import React from 'react';

const OptionButton = (props) => {
  return (
    <button
      className={props.active ? 'active' : ''}
      onClick={() => props.setMetric(props.metric)}
    >
      <span>{props.buttonText}</span>
      <span>{props.buttonIcon}</span>
    </button>
  );
};

const Options = (props) => {
  const { options, activeMetric, setMetric, icon } = props;

  const OptionButtons = options.map(option => (
    <OptionButton
      active={option.metric === activeMetric}
      metric={option.metric}
      setMetric={setMetric}
      buttonText={option.buttonText}
      buttonIcon={option.metric === 'change' ? icon : ''}
      key={option.metric}
    />
  ));

  return (
    <div className='options'>
      {OptionButtons}
    </div>
  );
};

export default Options;
